import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditFinancialExtension
 */
@Entity()
export class BaseKPFEditFinancialExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditFinancialExtension';
}
